import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import styles from "./LandingPage.module.css";
import { AboutUsLine, StarIcon } from "../../svgImage";
import { ManualImageCarousel } from "../custom/Carousel";

const CustomerLove = () => {
  const isMobile = useMediaQuery("(max-width:468px)");
  const cards = [
    {
      msg: "This place is a gem for gifting, savouries and bakery itemsThey have amazing verties of diwali gift hampers. You can customise according to your preference",
      name: "Eatthis Ahmedabad",
      ratting: 5,
    },
    {
      msg: "It is really really yummy n healthy food with best service. Their all cookies are best but Most I like is gluten free cookies which is made with lots of fibers n jaggery.",
      name: "Nitaben Vyas",
      ratting: 5,
    },
    {
      msg: "A delightful cloud kitchen offering fresh, flavorful snacks, baked goods, and gift hampers. From creamy guacamole to moist muffins, every item is delicious and perfectly made — ideal for both indulgence and gifting.",
      name: "Ahmedabad Foodies",
      ratting: 5,
    },
    {
      msg: "The cupcakes and cookies from Prasadam were divine! Perfectly baked fresh and with just the right amount of sweetness. The packaging was elegant making it a perfect gift option.",
      name: "Jaspreet singh sandhu",
      ratting: 5,
    },
    {
      msg: "So convenient and best service. Bhavi mam herself is very friendly and provides food on time with best quality. She organised 1100 gift hampers for me on urgent basis and that too with best presentation and quality.",
      name: "NIDHISHREE DEEP",
      ratting: 5,
    },
  ];
  return (
    <Box
      maxWidth="940px"
      width="100%"
      margin="auto"
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      //   alignItems={{ xs: "flex-start", md: "center" }}
      mt={{ xs: "50px", md: "100px" }}
      gap={{ xs: 4, md: 3 }}
      px={{ xs: 2, sm: 3, md: 0 }}
    >
      {/* LEFT SECTION */}
      <Box>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          <AboutUsLine width={isMobile ? "60px" : "80px"} />
          <Typography
            className={styles.Aboutustext}
            paddingLeft={1}
            fontSize={{ xs: "18px", sm: "20px", md: "22px" }}
          >
            Love from <br />
            Our Customers
          </Typography>
        </Box>

        <Typography
          className={styles.AboutUsShortDiscription}
          mt="20px"
          fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
        >
          Every bite tells a story. Here’s what
          <br /> our customers have to say.
        </Typography>
      </Box>

      {/* RIGHT SECTION – CAROUSEL */}
      <Box
        width={{ xs: "100vw", md: "calc(100vw - ((100vw - 280px) / 2))" }}
        mt={{ xs: 2, md: 0 }}
      >
        <ManualImageCarousel cards={cards} CardDesign={ReviewMsg} />
      </Box>
    </Box>
  );
};

const ReviewMsg = ({ card }) => {
  return (
    <Box
      borderRadius={1}
      bgcolor={"#F4EBD7"}
      p={2}
      width={"300px"}
      height={"350px"}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
    >
      <Box>
        <Typography className={styles.reviewmsgDes}>{card?.msg}</Typography>
      </Box>
      <Box>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "1px",
            background: "#D2A67966",
          }}
        />
        <Box mt={2}>
          <Typography className={styles.reviewName}>{card?.name}</Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={0.5} mt={1}>
          {Array.from({ length: card?.ratting }).map((_, i) => (
            <StarIcon key={i} sx={{ color: "#f5b50a" }} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
export default CustomerLove;
